export default function ($translate) {
    return {
        KEYS: {
            COMPANY_BASED: 'COMPANY_BASED',
            COURSE_BASED: 'COURSE_BASED'
        },
        LABELS: {
            COMPANY_BASED: $translate.instant('certificate.company based'),
            COURSE_BASED: $translate.instant('certificate.course based')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/certificationNumberingType/index.js